export default function IconBulletPIN() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1978_22924)">
        <circle cx="10" cy="9.99967" r="9.16667" fill="#CCEEE1" />
        <circle cx="10" cy="10" r="5" fill="#00AB6B" />
      </g>
      <defs>
        <clipPath id="clip0_1978_22924">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
